import { CategoriesGridOneSItem } from '../CategoriesGridOneSBlock/CategoriesGridOneSBlock';
import { cfSrcForImage } from '../utils';

export const formatSrcToCSSUrl = (
  item: CategoriesGridOneSItem,
  size: number,
) => {
  if (!item.img) {
    return '';
  }

  return `, url('${cfSrcForImage(item.img, { width: size, height: size })}')`;
};
